interface TagChipsProps {
  values: string[];
  onRemove: (value: string) => void;
  /**
   * Rótulo exibido no chip. O valor bruto continua sendo o que é
   * armazenado/enviado; isto só afeta a exibição (ex.: `scopeId` → "label (id)").
   */
  formatValue?: (value: string) => string;
}

/**
 * Lista de chips removíveis. Compartilhada por {@link TagListInput} (entrada
 * livre) e `ScopeListInput` (escolha de uma lista), para as duas formas de
 * montar a lista terminarem com a mesma aparência.
 */
export function TagChips({ values, onRemove, formatValue }: TagChipsProps) {
  if (values.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-1.5">
      {values.map((value) => (
        <span
          key={value}
          className="border-(--color-border) bg-(--color-bg-secondary) text-(--color-text-primary) inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs"
        >
          <span className="font-mono">
            {formatValue ? formatValue(value) : value}
          </span>
          <button
            type="button"
            onClick={() => onRemove(value)}
            className="text-(--color-text-secondary) hover:text-(--color-text-primary)"
            aria-label={`Remover ${value}`}
          >
            ×
          </button>
        </span>
      ))}
    </div>
  );
}
